import { encryptData } from '../helpers/encrypt/crypto-encrypt'
import baseUrl, { urls } from '../store/endPoints'
import uris from './uris'
 
const TIMEOUT = 1800000
const SESSION_EXPIRE_STATUS = 498
const LIMIT_EXCEEDS_STATUS = 429
 
const handleSessionExpired = () => {
    sessionStorage.clear()
    const url = new URL(uris.login, window.location.origin)
    url.searchParams.set('sessionExpired', 'true')
    window.location.href = url.toString()
}
 
const handleStatus = async ({ status, response, url }) => {
    const excludedUrls = [urls?.fileUpload]
 
    if (status === SESSION_EXPIRE_STATUS) {
        handleSessionExpired()
        return false
    } else if (status === LIMIT_EXCEEDS_STATUS) {
        let limit_exceeds = { issue: true }
        if (excludedUrls?.includes(url)) limit_exceeds.modal = false
        else limit_exceeds.modal = true
 
        sessionStorage.limit_exceeds = encryptData(limit_exceeds)
 
        const currentPageUrl = new URL(window.location.href)
        currentPageUrl.searchParams.set('limit-exceeded', 'true')
        window.history.replaceState(null, '', currentPageUrl.toString())
        return false
    } else {
        return true
    }
}
 
/**
 * @description function to handle the time out error
 * @param  {Promise} promise
 * @param  {number} timeout
 * @param  {string} error
 * @return
 */
function timeoutPromise(promise, timeout, error) {
    return new Promise((resolve, reject) => {
        const clearTimeOut = setTimeout(() => {
            reject(error)
        }, timeout)
        promise.then(
            (data) => {
                clearTimeout(clearTimeOut)
                resolve(data)
            },
            (data) => {
                clearTimeout(clearTimeOut)
                reject(data)
            },
        )
    })
}
 
/** @description Sending a GET request to JSON API.
 * doGet method resolves or rejects the promise that is obtained
 * from the fetchURl method
 * @param {string} url
 * @param {string} urlPrefix
 * @returns {object}
 */
export const doGet = (url, timeOut = TIMEOUT, urlPrefix = baseUrl) =>
    timeoutPromise(
        fetch(
            urlPrefix.concat(url),
            Object.assign(
                {},
                {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        Accept: 'application/json; charset=UTF-8',
                        'Access-Control-Allow-Origin': '*',
                    },
                    credentials: 'include',
                },
            ),
        ),
        timeOut,
        504,
    ).then((res) => {
        let response = null
        response = res.json()
        handleStatus({ status: res.status, response, url })
 
        if (res.ok) {
            return response
        }
 
        return response.then((error) => {
            throw error
        })
    })
 
/** @description Sending a POST request.
 * @param {string} url
 * @param {object} body
 * @param {string} urlPrefix
 * @returns {Promise}
 */
export const doPost = (url, body, timeOut = TIMEOUT, urlPrefix = baseUrl) =>
    timeoutPromise(
        fetch(
            urlPrefix.concat(url),
            Object.assign(
                {},
                {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        Accept: 'application/json; charset=UTF-8',
                        'Access-Control-Allow-Origin': '*',
                    },
                    credentials: 'include',
                    body: JSON.stringify(body),
                },
            ),
        ),
        timeOut,
        504,
    ).then((res) => {
        let response = null
        response = res.json()
        handleStatus({ status: res.status, response, url })
 
        if (res.ok) {
            return response
        }
 
        return response.then((error) => {
            throw error
        })
    })
 
/** @description Sending a PUT request.
 * @param {string} url
 * @param {object} body
 * @param {string} urlPrefix
 * @returns {Promise}
 */
export const doPut = (url, body, timeOut = TIMEOUT, urlPrefix = baseUrl) =>
    timeoutPromise(
        fetch(
            urlPrefix.concat(url),
            Object.assign(
                {},
                {
                    method: 'put',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        Accept: 'application/json; charset=UTF-8',
                        'Access-Control-Allow-Origin': '*',
                    },
                    credentials: 'include',
                    body: JSON.stringify(body),
                },
            ),
        ),
        timeOut,
        504,
    ).then((res) => {
        let response = null
        response = res.json()
        handleStatus({ status: res.status, response, url })
 
        if (res.ok) {
            return response
        }
 
        return response.then((error) => {
            throw error
        })
    })
 
/** @description Sending a DELETE request.
 * @param {string} url
 * @param {object} body
 * @param {string} urlPrefix
 * @returns {Promise}
 */
export const doDelete = (url, body, timeOut = TIMEOUT, urlPrefix = baseUrl) =>
    timeoutPromise(
        fetch(
            urlPrefix.concat(url),
            Object.assign(
                {},
                {
                    method: 'delete',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        Accept: 'application/json; charset=UTF-8',
                        'Access-Control-Allow-Origin': '*',
                    },
                    credentials: 'include',
                    body: JSON.stringify(body),
                },
            ),
        ),
        timeOut,
        504,
    ).then((res) => {
        let response = null
        response = res.json()
        handleStatus({ status: res.status, response, url })
 
        if (res.ok) {
            return response
        }
 
        return response.then((error) => {
            throw error
        })
    })
 
/** @description Sending a POST FILE request* */
export const doPostFile = (url, body, timeOut = TIMEOUT, urlPrefix = baseUrl) =>
    timeoutPromise(
        fetch(
            urlPrefix.concat(url),
            Object.assign(
                {},
                {
                    method: 'post',
                    credentials: 'include',
                    body,
                },
            ),
        ),
        timeOut,
        504,
    ).then((res) => {
        let response = null
        response = res.json()
        handleStatus({ status: res.status, response, url })
 
        if (res.ok) {
            return response
        }
 
        return response.then((error) => {
            throw error
        })
    })
 
/** @description Sending a POST FILE request* */
export const doPutFile = (url, body, timeOut = TIMEOUT, urlPrefix = baseUrl) =>
    timeoutPromise(
        fetch(
            urlPrefix.concat(url),
            Object.assign(
                {},
                {
                    method: 'put',
                    credentials: 'include',
                    body,
                },
            ),
        ),
        timeOut,
        504,
    ).then((res) => {
        let response = null
        response = res.json()
        handleStatus({ status: res.status, response, url })
 
        if (res.ok) {
            return response
        }
 
        return response.then((error) => {
            throw error
        })
    })
 
/** @description Sending a POST Come Download File request.
 * @param {string} url
 * @param {object} body
 * @param {string} urlPrefix
 * @returns {Promise}
 */
export const doPostDownload = (url, body, timeOut = TIMEOUT, urlPrefix = baseUrl) =>
    timeoutPromise(
        fetch(
            urlPrefix.concat(url),
            Object.assign(
                {},
                {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        Accept: 'application/json; charset=UTF-8',
                        'Access-Control-Allow-Origin': '*',
                    },
                    credentials: 'include',
                    body: JSON.stringify(body),
                },
            ),
        ),
        timeOut,
        504,
    )
        .then((res) => {
            const response = res.clone()
            const fileName = res?.headers?.get('content-disposition')?.split('=')[1]
 
            const reader = res.body.getReader()
 
            handleStatus({ status: res.status, response, url })
 
            if (res.ok) {
                return {
                    stream: new ReadableStream({
                        start(controller) {
                            return pump()
                            function pump() {
                                return reader.read().then(({ done, value }) => {
                                    // When no more data needs to be consumed, close the stream
                                    if (done) {
                                        controller.close()
                                        return
                                    }
                                    // Enqueue the next data chunk into our target stream
                                    controller.enqueue(value)
                                    return pump()
                                })
                            }
                        },
                    }),
                    fileName,
                }
            } else {
                return response.json().then((error) => {
                    throw error
                })
            }
        })
        // Create a new response out of the stream
        .then(({ stream, fileName }) => ({ res: new Response(stream), fileName }))
        // Create an object URL for the response
        .then(({ res, fileName }) => res.blob().then((blob) => ({ blob, fileName })))
        .then(({ blob, fileName }) => ({
            url: URL.createObjectURL(blob),
            fileName,
        }))
        // Update URL
        .then(({ url, fileName }) => {
            exportExcelFunction({ blobURL: url, name: fileName })
            return { name: fileName, blobURL: url }
            // const newWindow = window.open(url, 'Download')
            // if (newWindow) newWindow.opener = null;
        })
        .catch((error) => {
            throw error
        })
 
export const exportExcelFunction = (data) => {
    let anchorTagElement = document.createElement('a')
    document.body.appendChild(anchorTagElement)
    anchorTagElement.style = 'display: none'
 
    anchorTagElement.href = data.blobURL
    anchorTagElement.download = data.name || `HTML_Report_${Date.now()}.html`
    anchorTagElement.click()
    window.URL.revokeObjectURL(data.blobURL)
}
 
/** @description Sending a GET request for downloading a file.
 * @param {string} url
 * @param {string} urlPrefix
 * @returns {Promise}
 */
 
export const doGetDownload = (url, timeOut = TIMEOUT, urlPrefix = baseUrl) => {
    return timeoutPromise(
        fetch(urlPrefix.concat(url), {
            method: 'get',
            headers: {
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Access-Control-Allow-Origin': '*',
            },
            credentials: 'include',
        }),
        timeOut,
        504,
    )
        .then((res) => {
            const response = res?.headers?.get('content-disposition')
 
            let fileName = response ? response.split('=')[1] : 'downloaded-file'
 
            if (res.ok) {
                const reader = res.body.getReader()
                return {
                    stream: new ReadableStream({
                        start(controller) {
                            function pump() {
                                return reader.read().then(({ done, value }) => {
                                    if (done) {
                                        controller.close()
                                        return
                                    }
                                    controller.enqueue(value)
                                    return pump()
                                })
                            }
                            pump()
                        },
                    }),
                    fileName,
                }
            } else {
                return res
                    .json()
                    .catch(() => {
                        throw new Error('An unexpected error occurred.')
                    })
                    .then((error) => {
                        throw error
                    })
            }
        })
        .then(({ stream, fileName }) => {
            return new Response(stream).blob().then((blob) => ({
                blob,
                fileName,
            }))
        })
        .then(({ blob, fileName }) => {
            const url = URL.createObjectURL(blob)
 
            const link = document.createElement('a')
            link.href = url
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
 
            return { url: url, fileName: fileName }
        })
        .catch((error) => {
            throw error
        })
}
 
// Helper Function To Revoke Object URL From Client.
export const revokeObjectURL = (blobURL = '') => URL.revokeObjectURL(blobURL)
 